import React from "react";

export default function Section9() {
  const reasons = [
    {
      title: "E-commerce & Retail",
      description: "Helps e-commerce and retail brands increase online sales through targeted ads that bring in high-intent shoppers.Campaigns are optimized to reduce wasted spend and improve conversion rates.",
    },
    {
      title: " Real Estate",
      description: "Supports real estate professionals by generating qualified buyer and seller leads.Improves listing visibility and helps agents connect with ready-to-convert clients",
    },
    {
      title: "Healthcare & Clinics",
      description: "Helps clinics and healthcare providers increase patient bookings through local, compliant campaigns.Focus is on reaching people actively searching for medical services in their area",
    },
    {
      title: "SaaS & Technology",
      description: "Drives more sign-ups, demos, and trials for SaaS and tech companies.Campaigns are built to improve user acquisition and support scalable growth.",
    },
    {
      title: "Finance & Insurance",
      description: "Helps financial and insurance businesses generate high-quality, intent-driven leads.Focus is on reaching qualified prospects who are ready to take action.",
    },
     {
      title: "Hospitality & Travel",
      description: "Increases bookings and inquiries for hotels and travel businesses across Texas.Campaigns target users at the exact moment they are planning to book or travel",
    }, {
      title: "Startups & Small Businesses",
      description: "Helps startups grow faster with cost-efficient performance marketing strategies.Focus is on generating early traction and building a strong customer base.",
    },
  ];

  return (
    <div className="w-full Section12">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        {/* Main Heading */}
        <h2 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
          Industries We Serve with Performance Marketing in Texas
        </h2>
        <p className="mt-5 mb-10">
            Mean3 provides performance marketing services designed to help businesses across Texas grow with measurable results. Each industry gets a tailored approach focused on improving leads, sales, and overall ROI
        </p>

        {/* Cards container */}
        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {reasons.map((item, index) => (
            <div
              key={index}
              className={`p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%] rounded-[8px] ${
                index % 2 === 0
                  ? "bg-[#E42E35] text-white"
                  : "bg-[#f5f5f5] text-[#373737]"
              }`}
            >
              <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {item.title}
              </h3>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
